import {lshGETAUTH} from './core';
import {graphqlRequestHandler} from './core';
import {
  IFarmInputPurchaseOrder,
  IGenericResponse,
  IGenericType,
  IPurchaseOrderSupportingDocumentInput,
  ISupportingDocument,
} from 'constants/interfaces';

export async function apiGetPurchaseOrders(
  limit?: number,
): Promise<IFarmInputPurchaseOrder[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {limit};
    return new Promise((resolve, reject) => {
      const query = `
                query variables($limit: Int){
                    farmInputPurchaseOrders(limit: $limit){
                        id
                        createdDate
                        updatedDate
                        documentUrl
                        gpayReceiptNo
                        gpayWithdrawDate
                        trackingReference
                        expectedPaymentDate
                        orders{
                            quantity
                            price
                        }
                        supportingDocuments{
                            id
                            title
                            url
                            createdDate
                        }
                        gpayWithdrawUser{
                          id
                          name
                          surname
                        }
                        statusUpdates{
                            id
                            date
                            status{
                                id
                                name
                            }
                            user{
                                name
                                surname
                            }
                        }
                        invoice{
                            id
                            invoiceNumber
                            insertedDate
                            updatedDate
                            isPaid
                            latitude
                            longitude
                            address
                            total
                            outstanding
                            deliveryType
                            logisticsCost
                            vatExempt
                            orders{
                                id
                                quantity
                                price
                                isDelivered
                                dueDate
                                logisticsType
                                logisticsTypeName
                                product{
                                    id
                                    name
                                    category
                                    stockCode
                                    size
                                    price
                                    measurement
                                    grade
                                    activeIngredient
                                    tradeName
                                    image
                                }
                            }
                            farmer{
                                id
                                name
                                surname
                                email
                                phone
                                image
                                address
                                farm{
                                    id
                                    name
                                    sizeHectares
                                    type
                                    turnover
                                    numberOfEmployees
                                    province
                                    latLong
                                }
                            }
                            depot{
                                name
                                mainSupplier{
                                    name
                                }
                            }
                        }
                    }
                }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrders',
        query,
        variables,
        headers,
      )
        .then((purchaseOrders: IFarmInputPurchaseOrder[]) => {
          resolve(purchaseOrders);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetPurchaseOrder(input: {
  id?: number;
  invoiceId?: number;
}): Promise<IFarmInputPurchaseOrder> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = input;
    return new Promise((resolve, reject) => {
      const query = `
                query variables($id: ID, $invoiceId: ID){
                    farmInputPurchaseOrder(id: $id, invoiceId: $invoiceId){
                        id
                        createdDate
                        updatedDate
                        documentUrl
                        gpayReceiptNo
                        gpayWithdrawDate
                        trackingReference
                        expectedPaymentDate
                        orders{
                            id
                            quantity
                            price
                            isDelivered
                            dueDate
                            logisticsType
                            logisticsTypeName
                            product{
                                id
                                name
                                category
                                stockCode
                                size
                                price
                                measurement
                                grade
                                activeIngredient
                                tradeName
                                image
                                mainSupplier{
                                    id
                                    name
                                }
                                depot{ id name }
                            }
                        }
                        supportingDocuments{
                            id
                            title
                            url
                            createdDate
                        }
                        gpayWithdrawUser{
                          id
                          name
                          surname
                        }
                        statusUpdates{
                            id
                            date
                            status{
                                id
                                name
                            }
                            user{
                                name
                                surname
                            }
                        }
                        invoice{
                            id
                            invoiceNumber
                            insertedDate
                            updatedDate
                            isPaid
                            latitude
                            longitude
                            address
                            total
                            outstanding
                            deliveryType
                            logisticsCost
                            vatExempt
                            orders{
                                id
                                quantity
                                price
                                isDelivered
                                dueDate
                                logisticsType
                                logisticsTypeName
                                product{
                                    id
                                    name
                                    category
                                    stockCode
                                    size
                                    price
                                    measurement
                                    grade
                                    activeIngredient
                                    tradeName
                                    image
                                }
                            }
                            farmer{
                                id
                                name
                                surname
                                email
                                phone
                                image
                                address
                                farm{
                                    id
                                    name
                                    sizeHectares
                                    type
                                    turnover
                                    numberOfEmployees
                                    province
                                    latLong
                                }
                            }
                            depot{
                                name
                                mainSupplier{
                                    name
                                }
                            }
                        }
                    }
                }`;
      graphqlRequestHandler('farmInputPurchaseOrder', query, variables, headers)
        .then((purchaseOrder: IFarmInputPurchaseOrder) => {
          resolve(purchaseOrder);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiUpdatePurchaseOrderStatus(
  id: number,
  statusId: number,
): Promise<IFarmInputPurchaseOrder> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {id, statusId};
    return new Promise((resolve, reject) => {
      const query = `
                mutation variables($id: ID!, $statusId: ID!){
                    farmInputPurchaseOrderUpdateStatus(id: $id, statusId: $statusId){
                        id
                        createdDate
                        updatedDate
                        documentUrl
                        gpayReceiptNo
                        gpayWithdrawDate
                        trackingReference
                        expectedPaymentDate
                        supportingDocuments{
                            id
                            title
                            url
                            createdDate
                        }
                        gpayWithdrawUser{
                          id
                          name
                          surname
                        }
                        statusUpdates{
                            id
                            date
                            status{
                                id
                                name
                            }
                            user{
                                name
                                surname
                            }
                        }
                        invoice{
                            id
                            invoiceNumber
                            insertedDate
                            updatedDate
                            isPaid
                            latitude
                            longitude
                            address
                            total
                            outstanding
                            deliveryType
                            logisticsCost
                            vatExempt
                            orders{
                                id
                                quantity
                                price
                                isDelivered
                                dueDate
                                logisticsType
                                logisticsTypeName
                                product{
                                    id
                                    name
                                    category
                                    stockCode
                                    size
                                    price
                                    measurement
                                    grade
                                    activeIngredient
                                    tradeName
                                    image
                                }
                            }
                            farmer{
                                id
                                name
                                surname
                                email
                                phone
                                image
                                address
                                farm{
                                    id
                                    name
                                    sizeHectares
                                    type
                                    turnover
                                    numberOfEmployees
                                    province
                                    latLong
                                }
                            }
                            depot{
                                name
                                mainSupplier{
                                    name
                                }
                            }
                        }
                    }
                }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrderUpdateStatus',
        query,
        variables,
        headers,
      )
        .then((purchaseOrder: IFarmInputPurchaseOrder) => {
          resolve(purchaseOrder);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiSavePurchaseOrder(input: {
  id?: number;
  invoiceId?: number;
  trackingReference?: string;
  expectedPaymentDate?: Date;
}): Promise<IFarmInputPurchaseOrder> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {input};
    return new Promise((resolve, reject) => {
      const query = `
                mutation variables($input: FarmInputPurchaseOrderInput!){
                    farmInputPurchaseOrderSave(input: $input){
                        id
                        createdDate
                        updatedDate
                        documentUrl
                        gpayReceiptNo
                        gpayWithdrawDate
                        trackingReference
                        expectedPaymentDate
                        supportingDocuments{
                            id
                            title
                            url
                            createdDate
                        }
                        gpayWithdrawUser{
                          id
                          name
                          surname
                        }
                        statusUpdates{
                            id
                            date
                            status{
                                id
                                name
                            }
                            user{
                                name
                                surname
                            }
                        }
                        invoice{
                            id
                            invoiceNumber
                            insertedDate
                            updatedDate
                            isPaid
                            latitude
                            longitude
                            address
                            total
                            outstanding
                            deliveryType
                            vatExempt
                            logisticsCost
                            orders{
                                id
                                quantity
                                price
                                isDelivered
                                dueDate
                                logisticsType
                                logisticsTypeName
                                product{
                                    id
                                    name
                                    category
                                    stockCode
                                    size
                                    price
                                    measurement
                                    grade
                                    activeIngredient
                                    tradeName
                                    image
                                }
                            }
                            farmer{
                                id
                                name
                                surname
                                email
                                phone
                                image
                                address
                                farm{
                                    id
                                    name
                                    sizeHectares
                                    type
                                    turnover
                                    numberOfEmployees
                                    province
                                    latLong
                                }
                            }
                            depot{
                                name
                                mainSupplier{
                                    name
                                }
                            }
                        }
                    }
                }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrderSave',
        query,
        variables,
        headers,
      )
        .then((purchaseOrder: IFarmInputPurchaseOrder) => {
          resolve(purchaseOrder);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetPurchaseOrderStatuses(): Promise<IGenericType[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {};
    return new Promise((resolve, reject) => {
      const query = `
          query{
            farmInputPurchaseOrderStatuses{
              id
              name
            }
          }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrderStatuses',
        query,
        variables,
        headers,
      )
        .then((purchaseOrderStatuses: IGenericType[]) =>
          resolve(purchaseOrderStatuses),
        )
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetPurchaseOrderSupportingDocuments(
  purchaseOrderId: number | string,
): Promise<ISupportingDocument[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {purchaseOrderId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables(
            $purchaseOrderId: ID!
          ){
            farmInputPurchaseOrderSupportingDocuments(
              purchaseOrderId: $purchaseOrderId
            ){
              id
              purchaseOrderId
              title
              url
              createdDate
            }
          }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrderSupportingDocuments',
        query,
        variables,
        headers,
      )
        .then((response: ISupportingDocument[]) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiSavePurchaseOrderSupportingDocument(
  input: IPurchaseOrderSupportingDocumentInput,
): Promise<ISupportingDocument> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {input};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $input: PurchaseOrderSupportingDocumentInput!
          ){
            farmInputPurchaseOrderSupportingDocumentSave(
              input: $input
            ){
              id
              purchaseOrderId
              title
              url
              createdDate
            }
          }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrderSupportingDocumentSave',
        query,
        variables,
        headers,
      )
        .then((response: ISupportingDocument) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetPurchaseOrdersByInvoice(
  invoiceId: number,
): Promise<IFarmInputPurchaseOrder[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {invoiceId};
    return new Promise((resolve, reject) => {
      const query = `
        query variables($invoiceId: ID) {
          farmInputPurchaseOrders(invoiceId: $invoiceId) {
            id
            createdDate
            updatedDate
            documentUrl
            proformaInvoiceUrl
            gpayReceiptNo
            gpayWithdrawDate
            trackingReference
            expectedPaymentDate
            supportingDocuments {
              id
              title
              url
              createdDate
            }
            orders{
                quantity
                price
            }
            gpayWithdrawUser {
              id
              name
              surname
            }
            statusUpdates {
              id
              date
              status { id name }
              user { name surname }
            }
            invoice {
              id
              invoiceNumber
              insertedDate
              updatedDate
              isPaid
              total
              outstanding
              deliveryType
              logisticsCost
              vatExempt
              orders {
                id
                quantity
                price
                isDelivered
                dueDate
                logisticsType
                logisticsTypeName
                product {
                  id
                  name
                  category
                  stockCode
                  size
                  price
                  measurement
                  grade
                  activeIngredient
                  tradeName
                  image
                }
              }
              farmer {
                id
                name
                surname
                email
                phone
                image
                address
                farm { id name sizeHectares province }
              }
              depot {
                name
                mainSupplier { name }
              }
            }
          }
        }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrders',
        query,
        variables,
        headers,
      )
        .then((purchaseOrders: IFarmInputPurchaseOrder[]) =>
          resolve(purchaseOrders),
        )
        .catch(reject);
    });
  });
}

export async function apiGeneratePurchaseOrderPdf(
  id: number | string,
): Promise<{success: boolean; url?: string; message?: string}> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {id};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($id: ID!) {
            farmInputPurchaseOrderGeneratePdf(id: $id) {
              success
              message
              url
            }
          }`;
      graphqlRequestHandler(
        'farmInputPurchaseOrderGeneratePdf',
        query,
        variables,
        headers,
      )
        .then((response) => resolve(response))
        .catch(reject);
    });
  });
}

export async function apiConvertTaxInvoice(
  invoiceId: number | string,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {invoiceId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $invoiceId: ID!
          ){
            farmInputInvoiceConvertProformaToTax(invoiceId: $invoiceId){
              success
              message
            }
          }`;
      graphqlRequestHandler(
        'farmInputInvoiceConvertProformaToTax',
        query,
        variables,
        headers,
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}
